var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseGroup',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}]},'BaseGroup',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_c('div',{staticClass:"default-area"},[_vm._v("组-占位区")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }